(function () {
  var root = document.querySelector('[data-lmx]');
  if (!root) return;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- marquees: clone each track once for a seamless loop ---- */
  if (!RM) root.querySelectorAll('.lmx-mq').forEach(function (mq) {
    var t = mq.querySelector('.lmx-mq__track'); if (!t) return;
    var c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = -1; });
    mq.appendChild(c);
  });

  /* ---- intro ---- */
  requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-ready'); }); });

  /* ---- scroll reveals ---- */
  root.querySelectorAll('.lmx-pain, .lmx-faq__item').forEach(function (el, i) { el.setAttribute('data-rv', ''); el.style.setProperty('--i', i % 6); });
  var rvs = root.querySelectorAll('[data-rv]');
  if ('IntersectionObserver' in window && !RM) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    rvs.forEach(function (el) { io.observe(el); });
  } else { rvs.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---- count-up stats ---- */
  var stats = root.querySelector('.lmx-stats');
  if (stats && 'IntersectionObserver' in window && !RM) {
    var nums = stats.querySelectorAll('[data-count]');
    nums.forEach(function (n) { n.textContent = '0'; });
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var t0 = performance.now();
      (function tick(t) {
        var p = Math.min(1, (t - t0) / 1400), k = 1 - Math.pow(1 - p, 3);
        nums.forEach(function (n) { n.textContent = Math.round(+n.dataset.count * k); });
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    }, { threshold: .4 }).observe(stats);
  }

  /* ---- hero parallax (mouse + scroll) ---- */
  var stage = root.querySelector('[data-parallax]');
  if (stage && !RM) {
    var st = stage.querySelector('.lmx-hero__stage');
    if (FINE) {
      root.querySelector('.lmx-hero').addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var mx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
        var my = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
        stage.style.setProperty('--mx', mx.toFixed(3)); stage.style.setProperty('--my', my.toFixed(3));
        st.style.setProperty('--mx', mx.toFixed(3)); st.style.setProperty('--my', my.toFixed(3));
      });
      root.querySelector('.lmx-hero').addEventListener('pointerleave', function () {
        ['--mx', '--my'].forEach(function (p) { stage.style.setProperty(p, 0); st.style.setProperty(p, 0); });
      });
    }
    var back = stage.querySelector('.lmx-hero__back');
    var onScroll = function () { var y = Math.min(window.scrollY, 800); back.style.setProperty('--sy', y + 'px'); };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- card tilt (look inside) ---- */
  if (FINE && !RM) {
    root.querySelectorAll('[data-tilt]').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        c.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); c.style.setProperty('--rx', (y * -10).toFixed(2) + 'deg');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
    });
    /* bento spotlight */
    root.querySelectorAll('.lmx-inc__card').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--x', (e.clientX - r.left) + 'px'); c.style.setProperty('--y', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---- week planner (structure only; details live in the PDF) ---- */
  try {
    var week = JSON.parse(document.getElementById('lmx-week-data').textContent);
    var panel = root.querySelector('[data-lmx-panel]');
    var tabs = root.querySelectorAll('.lmx-wk__tab');
    var notes = { Higher: 'More training fuel today.', Lower: 'Lighter on fuel today.', Flexible: 'Eat to hunger.' };
    var f = function (k) { return panel.querySelector('[data-f="' + k + '"]'); };
    var show = function (i, anim) {
      var d = week[i];
      f('n').textContent = d.n; f('m').textContent = d.m; f('t').textContent = d.t;
      f('c').textContent = d.c; f('fuel').textContent = d.fuel; f('fuelnote').textContent = notes[d.fuel] || '';
      f('gym').hidden = !d.gym; f('rest').hidden = d.gym;
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      if (anim) { panel.classList.remove('is-swap'); void panel.offsetWidth; panel.classList.add('is-swap'); }
    };
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i, true); }); });
    show(0, false);
  } catch (e) {}

  /* ---- look-inside rail ---- */
  var track = root.querySelector('[data-lmx-track]');
  var bar = root.querySelector('[data-lmx-bar]');
  if (track) {
    var step = function (dir) {
      var item = track.querySelector('.lmx-peek__item');
      var w = item ? item.getBoundingClientRect().width + 22 : 300;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    root.querySelector('[data-lmx-prev]').addEventListener('click', function () { step(-1); });
    root.querySelector('[data-lmx-next]').addEventListener('click', function () { step(1); });
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / track.scrollWidth;
      bar.style.width = (vis * 100) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
    };
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* ---- before/after + one-time hint sweep ---- */
  root.querySelectorAll('[data-lmx-ba]').forEach(function (fig) {
    var r = fig.querySelector('.lmx-ba__range'), touched = false;
    var set = function (v) { fig.style.setProperty('--pos', v + '%'); r.value = v; };
    r.addEventListener('input', function () { touched = true; fig.style.setProperty('--pos', r.value + '%'); });
    if (RM || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var keys = [50, 28, 72, 50], t0 = null, dur = 2200;
      setTimeout(function () {
        (function tick(t) {
          if (touched) return; if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), seg = p * (keys.length - 1), i = Math.min(keys.length - 2, Math.floor(seg)), k = seg - i;
          k = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
          set((keys[i] + (keys[i + 1] - keys[i]) * k).toFixed(1));
          if (p < 1) requestAnimationFrame(tick);
        })(performance.now());
      }, 500);
    }, { threshold: .5 }).observe(fig);
  });

  /* ---- sticky buy bar ---- */
  var sticky = root.querySelector('[data-lmx-sticky]');
  var buy = document.getElementById('lmx-buy');
  var fin = root.querySelector('.lmx-final');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var past = false, atEnd = false;
    var setS = function () {
      var on = past && !atEnd;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = sticky.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; setS(); }).observe(buy);
    if (fin) new IntersectionObserver(function (e) { atEnd = e[0].isIntersecting; setS(); }, { threshold: .25 }).observe(fin);
  }
})();
